const availableEducationLevels = [
    {
        label: 'Pós-graduação',
        value: 'postgraduate'
    },
    {
        label: 'Faculdade',
        value: 'bachelor'
    },
    {
        label: 'Segundo grau',
        value: 'highschool_2'
    },
    {
        label: 'Primeiro grau',
        value: 'highschool_1'
    }
]

export default availableEducationLevels